/* SVD Super-quiz
   Flöde: ålder -> storlek -> behovs-checklista -> följdfrågor (flerval, max 3 områden)
   -> valfri e-post -> laddskärm -> resultat.
   Rekommendation: huvudprodukt från högst prioriterade valda området, övriga som komplement.
   Trion föreslås när valen täcker minst två av mage/mun/hud; är rekommendationen exakt
   trio-produkterna ersätter Trion-panelen "Lägg till allt"-raden helt.
   Godis-upsell med auto-aktiverad rabattkod. */
(function () {
  'use strict';

  var root = document.getElementById('svd-super-quiz');
  var app  = document.getElementById('sq-app');
  var rail = document.getElementById('sq-rail-progress');
  var dataEl = document.getElementById('sq-products');
  if (!root || !app || !dataEl) return;

  var PRODUCTS;
  try { PRODUCTS = JSON.parse(dataEl.textContent); } catch (e) { PRODUCTS = {}; }

  var DISCOUNT_CODE = root.dataset.discountCode || 'QUIZ20';
  var DISCOUNT_PCT  = root.dataset.discountPct || '20';
  var DISCOUNT_FACTOR = 1 - (parseFloat(DISCOUNT_PCT) || 20) / 100;

  /* ---------- Frågedata ---------- */

  var AGES = [
    { key: 'valp',   label: 'Valp',   hint: 'Under 1 år',        word: 'valp',       chip: '<1' },
    { key: 'vuxen',  label: 'Vuxen',  hint: '1 till 7 år',       word: 'vuxen hund', chip: '1–7' },
    { key: 'senior', label: 'Senior', hint: '8 år eller äldre',  word: 'senior',     chip: '8+' }
  ];

  var SIZES = [
    { key: 'liten',  label: 'Liten',      hint: 'Under 10 kg',   word: 'liten',      emoji: '🐕', iconSize: 's' },
    { key: 'mellan', label: 'Mellanstor', hint: '10 till 25 kg', word: 'mellanstor', emoji: '🐕', iconSize: 'm' },
    { key: 'stor',   label: 'Stor',       hint: 'Över 25 kg',    word: 'stor',       emoji: '🐕', iconSize: 'l' }
  ];

  /* Områden i prioritetsordning: först valda (i denna ordning) blir huvudprodukt. */
  var AREAS = [
    {
      key: 'mage',
      label: 'Mage & tarm',
      short: 'magen',
      hint: 'Lös mage, gaser eller äter gräs',
      icon: 'gut',
      product: 'magbalans',
      question: 'Vad känner du igen hos din hund?',
      options: [
        { label: 'Äter gräs eller slickar på saker', icon: 'grass',
          why: 'Gräsätande och slickande är klassiska tecken på obalans i magen. Magbalans är prebiotika som hjälper tarmfloran att hitta tillbaka till balans.' },
        { label: 'Lös eller ojämn mage', icon: 'drops',
          why: 'En lös och ojämn mage tyder ofta på en stressad tarmflora. Magbalans prebiotika ger de goda tarmbakterierna näring så magen stabiliseras.' },
        { label: 'Gaser och kurrande mage', icon: 'wind',
          why: 'Gaser och kurr är ett vanligt tecken på att tarmfloran är i obalans. Magbalans prebiotika hjälper magen att komma i balans igen.' },
        { label: 'Känslig mage vid foderbyte eller stress', icon: 'cycle',
          why: 'En känslig mage behöver stabilitet. Magbalans prebiotika bygger upp tarmfloran så att magen tål förändringar bättre.' }
      ]
    },
    {
      key: 'hud',
      label: 'Hud, päls & tassar',
      short: 'hud & päls',
      hint: 'Klåda, mjäll eller torra tassar',
      icon: 'sparkle',
      product: 'hudpals',
      question: 'Var sitter besvären?',
      options: [
        { label: 'Kliar eller biter sig ofta', icon: 'scratch',
          why: 'Klåda kommer ofta inifrån. Hud och Päls är en näringsrik olja med Omega-3 som stödjer huden där klådan börjar.' },
        { label: 'Torr hud, mjäll eller matt päls', icon: 'dryskin',
          why: 'Torr hud och matt päls är tecken på att fettsyrorna inte räcker till. Omega-3-oljan i Hud och Päls ger näring inifrån för friskare hud och mer glans.' },
        { label: 'Torra eller spruckna tassar', icon: 'paw',
          product: 'tassalva',
          why: 'Tassarna tar mest stryk av alla. Tassalvan skyddar, mjukgör och reparerar torra och spruckna trampdynor, året om.' }
      ]
    },
    {
      key: 'mun',
      label: 'Tänder & andedräkt',
      short: 'munhälsan',
      hint: 'Dålig andedräkt eller beläggningar',
      icon: 'tooth',
      product: 'smile',
      question: 'Vad märker du hos din hund?',
      options: [
        { label: 'Dålig andedräkt', icon: 'breath',
          why: 'Dålig andedräkt är ofta första tecknet på att munhälsan behöver stöd. SMILE+ strös bara över maten och motverkar orsaken, inte bara lukten.' },
        { label: 'Beläggningar eller missfärgade tänder', icon: 'toothdots',
          why: 'Beläggningar som inte borstas bort blir med tiden tandsten. SMILE+ motverkar plack dagligen, enkelt att strö över maten.' },
        { label: 'Rött eller irriterat tandkött', icon: 'toothalert',
          why: 'Irriterat tandkött är en varningssignal som är lätt att missa. SMILE+ stödjer hela munhälsan dagligen, direkt i matskålen.' }
      ]
    },
    {
      key: 'oro',
      label: 'Oro & stress',
      short: 'lugnet',
      hint: 'Ljudkänslig eller varvar upp lätt',
      icon: 'bolt',
      product: 'vardag',
      question: 'När märks oron mest?',
      options: [
        { label: 'Vid höga ljud som åska och smällare', icon: 'burst',
          why: 'Många hundar reagerar starkt på höga ljud. Vardag+ med magnesium och tryptofan hjälper nervsystemet att hålla sig lugnare. Ge det dagligen inför perioder med smällare och åska.' },
        { label: 'I nya miljöer eller när rutiner bryts', icon: 'house',
          why: 'Nya miljöer och brutna rutiner stressar många hundar. Vardag+ med magnesium och tryptofan ger ett dagligt stöd som gör förändringar lättare att hantera.' },
        { label: 'I vardagen, har svårt att varva ner', icon: 'spiral',
          why: 'Hundar som ständigt varvar upp behöver hjälp att hitta lugnet. Vardag+ med magnesium och tryptofan stödjer balansen i vardagen.' }
      ]
    }
  ];

  /* Standard-texter för komplementrader */
  var COMPLEMENT_WHY = {
    magbalans: 'Prebiotika som stödjer en stabil mage och tarm.',
    hudpals:   'Omega-3-olja för friskare hud och glansigare päls.',
    smile:     'Motverkar plack och dålig andedräkt. Strös över maten.',
    vardag:    'Magnesium och tryptofan för hundar som varvar upp.',
    tassalva:  'Skyddar och mjukgör torra, känsliga tassar.',
    trion:     'Magbalans, SMILE+ och Hud och Päls i ett paket, till paketpris.'
  };

  /* Säljpunkter per produkt (ur produktsidornas egna beskrivningar) */
  var PRODUCT_BULLETS = {
    magbalans: ['Prebiotika som stödjer tarmfloran', 'Strös enkelt över maten', 'En burk räcker cirka 30 doseringar'],
    hudpals:   ['Näringsrik olja rik på Omega-3', 'Pumpas direkt på maten', 'För friskare hud och glansigare päls'],
    smile:     ['Motverkar plack och dålig andedräkt', 'Strös över maten, ingen borstning krävs', 'Dagligt stöd för munhälsan'],
    vardag:    ['Magnesium och tryptofan', 'För ljudkänsliga hundar som varvar upp', 'Ges dagligen i maten'],
    tassalva:  ['Naturlig salva för trampdynorna', 'Skyddar och mjukgör året om', 'Lätt att stryka på'],
    trion:     ['Magbalans, SMILE+ och Hud och Päls', 'Helhetsstöd för mage, mun och päls', 'Billigare än att köpa separat']
  };

  /* Riktiga kundcitat, hämtade från butikens recensionssektioner */
  var PRODUCT_QUOTES = {
    magbalans: 'Min hunds magbesvär med lös mage är nu stabiliserad. Så glad att det hjälpte.',
    hudpals:   'Vår Golden retriever har hudproblem sen hon var liten, mycket klåda och mjäll. Detta har blivit mycket bättre.',
    smile:     'Redan efter en veckas användning märkte vi en skillnad på vår hunds andedräkt. Det fungerar verkligen.'
  };

  var STAR_PATH = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.2 6.6.8-4.9 4.6 1.3 6.5L12 16.9 6.1 20l1.3-6.5L2.5 9l6.6-.8z"/></svg>';

  /* Stjärnrad per produkt: bara när produkten har egna recensioner (Judge.me-metafält) */
  function starsRow(key, short) {
    var p = PRODUCTS[key] || {};
    var rating = parseFloat(p.rating) || 0;
    var count = parseInt(p.ratingCount, 10) || 0;
    /* visa bara betyg som säljer: minst 4,0 och minst 3 recensioner */
    if (rating < 4 || count < 3) return '';
    var five = STAR_PATH + STAR_PATH + STAR_PATH + STAR_PATH + STAR_PATH;
    var pct = Math.round((rating / 5) * 100);
    var txt = String(rating.toFixed(1)).replace('.', ',') + ' av 5 · ' + count +
      (short ? '' : (count === 1 ? ' recension' : ' recensioner'));
    return '<span class="sq-stars" aria-hidden="true">' +
      '<span class="sq-stars-bg">' + five + '</span>' +
      '<span class="sq-stars-fill" style="width:' + pct + '%">' + five + '</span>' +
      '</span><span class="sq-stars-txt">' + txt + '</span>';
  }

  function money(cents) {
    return Math.round(cents / 100) + ' kr';
  }

  var GODIS_KEYS = ['tjurmuskel', 'grisoron', 'notlunga', 'godistrion'];
  var GODIS_WHY = {
    tjurmuskel: 'Naturligt långtugg av 100 % svensk råvara.',
    grisoron:   'Klassiskt tugg, proteinrikt och utan tillsatser.',
    notlunga:   'Små belöningsbitar, perfekta vid träning.',
    godistrion: 'Grisöron, tjurmuskel och nötlunga i ett paket.'
  };

  /* ---------- State ---------- */

  var state = {
    age: null,
    size: null,
    areas: [],          /* valda områdesnycklar i AREAS-ordning */
    followups: {},      /* areaKey -> [valda optionsindex] */
    noneChosen: false,
    stepIndex: 0,       /* 0 = ålder, 1 = storlek, 2 = områden, 3+ = följdfrågor */
    discountActivated: false,
    emailDone: false,
    cartCount: 0
  };

  function activeAreas() {
    return AREAS.filter(function (a) { return !!PRODUCTS[a.product]; });
  }

  function followupAreas() {
    var chosen = activeAreas().filter(function (a) { return state.areas.indexOf(a.key) >= 0; });
    return chosen.slice(0, 3);
  }

  function totalSteps() {
    if (state.stepIndex <= 2) return 3 + Math.max(1, Math.min(3, state.areas.length));
    return 3 + followupAreas().length;
  }

  /* ---------- Render-hjälpare ---------- */

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html !== undefined) node.innerHTML = html;
    return node;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Egna linjeikoner (stroke, brandgrönt) – varje ikon matchar sitt alternativ */
  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICONS = {
    paw:        '<circle cx="7.2" cy="9" r="1.7"/><circle cx="12" cy="7.4" r="1.7"/><circle cx="16.8" cy="9" r="1.7"/><path d="M12 12.2c-2.6 0-4.8 2-4.8 4.2 0 1.4 1.1 2.5 2.4 2.5.9 0 1.6-.5 2.4-.5s1.5.5 2.4.5c1.3 0 2.4-1.1 2.4-2.5 0-2.2-2.2-4.2-4.8-4.2z"/>',
    gut:        '<path d="M5 7.5C5 5.6 6.6 4 8.5 4h7C17.4 4 19 5.6 19 7.5S17.4 11 15.5 11h-7C6.6 11 5 12.6 5 14.5S6.6 18 8.5 18h7c1.9 0 3.5-1.6 3.5-3.5"/><path d="M5 7.5V9M19 16.5V15"/>',
    sparkle:    '<path d="M12 4l1.9 5.1L19 11l-5.1 1.9L12 18l-1.9-5.1L5 11l5.1-1.9z"/><path d="M18.5 16.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/>',
    tooth:      '<path d="M12 5.2c-1.8 0-2.3-1-4-1C6 4.2 4.8 5.8 4.8 8c0 3.6 1.7 5.3 2.3 8.4.3 1.5.7 3.4 1.9 3.4 1.4 0 .9-3.6 3-3.6s1.6 3.6 3 3.6c1.2 0 1.6-1.9 1.9-3.4.6-3.1 2.3-4.8 2.3-8.4 0-2.2-1.2-3.8-3.2-3.8-1.7 0-2.2 1-4 1z"/>',
    toothdots:  '<path d="M12 5.2c-1.8 0-2.3-1-4-1C6 4.2 4.8 5.8 4.8 8c0 3.6 1.7 5.3 2.3 8.4.3 1.5.7 3.4 1.9 3.4 1.4 0 .9-3.6 3-3.6s1.6 3.6 3 3.6c1.2 0 1.6-1.9 1.9-3.4.6-3.1 2.3-4.8 2.3-8.4 0-2.2-1.2-3.8-3.2-3.8-1.7 0-2.2 1-4 1z"/><circle cx="9.8" cy="9.5" r="0.4"/><circle cx="13.8" cy="11" r="0.4"/>',
    toothalert: '<path d="M9.5 5c-1.5 0-1.9-.8-3.3-.8-1.7 0-2.7 1.3-2.7 3.2 0 3 1.4 4.4 1.9 7 .2 1.2.6 2.8 1.6 2.8 1.2 0 .7-3 2.5-3s1.3 3 2.5 3c1 0 1.4-1.6 1.6-2.8.5-2.6 1.9-4 1.9-7 0-1.9-1-3.2-2.7-3.2-1.4 0-1.8.8-3.3.8z"/><path d="M19.5 5v5"/><circle cx="19.5" cy="13.5" r="0.4"/>',
    bolt:       '<path d="M13.2 3.5L6.5 13.2H11l-1.4 7.3 6.9-9.7H12l1.2-7.3z"/>',
    heart:      '<path d="M12 20s-7-4.5-7-9.3C5 8.1 6.9 6.2 9.1 6.2c1.4 0 2.4.7 2.9 1.5.5-.8 1.5-1.5 2.9-1.5 2.2 0 4.1 1.9 4.1 4.5C19 15.5 12 20 12 20z"/>',
    grass:      '<path d="M5 20c.3-3.8-.5-6.4-2-8.5"/><path d="M9.5 20c0-5-.4-8.2-1.8-11.5"/><path d="M14.5 20c0-5 .6-8.5 2.2-11.5"/><path d="M19 20c.2-3.8 1.2-6.3 2.5-8"/><path d="M12 20c0-4.5 0-8 0-13"/>',
    drops:      '<path d="M8 4.5c1.3 1.8 2 2.9 2 4a2 2 0 1 1-4 0c0-1.1.7-2.2 2-4z"/><path d="M16 4.5c1.3 1.8 2 2.9 2 4a2 2 0 1 1-4 0c0-1.1.7-2.2 2-4z"/><path d="M12 12.5c1.5 2.1 2.3 3.3 2.3 4.6a2.3 2.3 0 1 1-4.6 0c0-1.3.8-2.5 2.3-4.6z"/>',
    wind:       '<path d="M3.5 8.5h8.5a2.3 2.3 0 1 0-2.3-2.3"/><path d="M3.5 12.5h13a2.3 2.3 0 1 1-2.3 2.3"/><path d="M3.5 16.5h6a1.8 1.8 0 1 1-1.8 1.8"/>',
    cycle:      '<path d="M6.5 9a6.5 6.5 0 0 1 10.7-2.5"/><path d="M17.5 3v4h-4"/><path d="M17.5 15a6.5 6.5 0 0 1-10.7 2.5"/><path d="M6.5 21v-4h4"/>',
    scratch:    '<path d="M5.5 5l5.5 9.5"/><path d="M10.5 3.5L16 13"/><path d="M15.5 2.5L21 12"/><path d="M4.5 18.5l2.5 2.5M8.5 17l2 2.5M12.5 15.5l1.5 2.5"/>',
    dryskin:    '<path d="M12 4.5c2.3 3 3.6 5 3.6 7a3.6 3.6 0 1 1-7.2 0c0-2 1.3-4 3.6-7z"/><path d="M4.5 19.5l15-15"/><circle cx="6" cy="9" r="0.4"/><circle cx="18.5" cy="15.5" r="0.4"/>',
    breath:     '<path d="M4 8c2 0 2 1.6 4 1.6S10 8 12 8s2 1.6 4 1.6S18 8 20 8"/><path d="M4 12.5c2 0 2 1.6 4 1.6s2-1.6 4-1.6 2 1.6 4 1.6 2-1.6 4-1.6"/><path d="M4 17c2 0 2 1.6 4 1.6S10 17 12 17s2 1.6 4 1.6 2-1.6 4-1.6"/>',
    burst:      '<path d="M12 2.5v4M12 17.5v4M2.5 12h4M17.5 12h4M5.3 5.3l2.8 2.8M15.9 15.9l2.8 2.8M18.7 5.3l-2.8 2.8M8.1 15.9l-2.8 2.8"/>',
    house:      '<path d="M4 11l8-7 8 7"/><path d="M6 9.5V19h12V9.5"/><path d="M10 19v-5h4v5"/>',
    spiral:     '<path d="M12 12a1.5 1.5 0 0 0 3 0 3.4 3.4 0 0 0-3.4-3.3A5.2 5.2 0 0 0 6.5 14a7 7 0 0 0 7 6.8 8.8 8.8 0 0 0 8-6.3"/><path d="M12 12a1.5 1.5 0 0 1-3 0"/>',
    truck:      '<path d="M2.5 7h11v9h-11z"/><path d="M13.5 10h3.6l3.4 3.2V16h-7"/><circle cx="6.8" cy="17.8" r="1.7"/><circle cx="16.6" cy="17.8" r="1.7"/>',
    undo:       '<path d="M9 5.5L5 9.5l4 4"/><path d="M5 9.5h9.5a4.5 4.5 0 0 1 0 9H10"/>'
  };

  /* Glada färger per ikon: tonad platta + kraftigare streck */
  var CHIP_COLORS = {
    coral:  { bg: '#FBE7E0', ink: '#D2603C' },
    amber:  { bg: '#FCF1D8', ink: '#C08A1E' },
    green:  { bg: '#E3F2E7', ink: '#2E8B57' },
    teal:   { bg: '#DFF2F0', ink: '#2E9188' },
    blue:   { bg: '#E3EEF9', ink: '#3B74BF' },
    purple: { bg: '#EEE9F8', ink: '#7A5FBF' }
  };
  var ICON_COLOR = {
    gut: 'coral', sparkle: 'amber', tooth: 'blue', bolt: 'purple', heart: 'green',
    grass: 'green', drops: 'blue', wind: 'teal', cycle: 'amber',
    scratch: 'coral', dryskin: 'blue', paw: 'amber',
    breath: 'teal', toothdots: 'blue', toothalert: 'coral',
    burst: 'amber', house: 'green', spiral: 'purple'
  };
  var CHIP_TEXT_COLOR = { '<1': 'green', '1–7': 'blue', '8+': 'purple' };

  function iconChip(iconOrChip, sizeClass, kind) {
    if (!iconOrChip) return '';
    var inner, colorKey;
    if (kind === 'chip') {
      inner = '<span class="sq-chip-txt">' + esc(iconOrChip) + '</span>';
      colorKey = CHIP_TEXT_COLOR[iconOrChip];
    } else if (kind === 'emoji') {
      inner = iconOrChip;
      colorKey = 'amber';
    } else {
      if (!ICONS[iconOrChip]) return '';
      inner = SVG_OPEN + ICONS[iconOrChip] + '</svg>';
      colorKey = ICON_COLOR[iconOrChip];
    }
    var c = CHIP_COLORS[colorKey] || CHIP_COLORS.green;
    return '<span class="sq-emoji' + (sizeClass ? ' sq-emoji--' + sizeClass : '') +
      '" style="background:' + c.bg + ';color:' + c.ink + '" aria-hidden="true">' + inner + '</span>';
  }

  function renderRail(current) {
    if (!rail) return;
    if (current === null) { rail.innerHTML = ''; return; }
    var total = totalSteps();
    var pct = Math.round((current / total) * 100);
    rail.innerHTML =
      '<p class="sq-rail-label">Fråga ' + (current + 1) + ' av ' + total + '</p>' +
      '<div class="sq-rail-track" role="progressbar" aria-valuenow="' + (current + 1) + '" aria-valuemin="1" aria-valuemax="' + total + '">' +
      '<span style="width:' + Math.max(pct, 6) + '%"></span></div>';
  }

  function backLink(onBack) {
    var b = el('button', 'sq-back', 'Tillbaka');
    b.type = 'button';
    b.addEventListener('click', onBack);
    return b;
  }

  function swap(node, current) {
    app.innerHTML = '';
    node.classList.add('sq-enter');
    app.appendChild(node);
    root.classList.toggle('sq-started', state.stepIndex > 0);
    renderRail(current === undefined ? null : current);
    var y = root.getBoundingClientRect().top + window.pageYOffset - 16;
    if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* Enfrågeval (ålder, storlek): klick går vidare direkt */
  function singleChoiceStep(cfg) {
    state.stepIndex = cfg.index;
    var card = el('div', 'sq-card');
    card.appendChild(el('h2', null, esc(cfg.question)));
    var opts = el('div', 'sq-options');
    cfg.choices.forEach(function (c) {
      var btn = el('button', 'sq-opt sq-opt-icon',
        (c.chip ? iconChip(c.chip, null, 'chip')
          : c.emoji ? iconChip(c.emoji, c.iconSize, 'emoji')
          : iconChip(c.icon, c.iconSize)) +
        '<span class="sq-opt-txt"><strong>' + esc(c.label) + '</strong><small>' + esc(c.hint) + '</small></span>');
      btn.type = 'button';
      if (cfg.selected === c.key) btn.classList.add('is-selected');
      btn.addEventListener('click', function () { cfg.onPick(c.key); });
      opts.appendChild(btn);
    });
    card.appendChild(opts);
    if (cfg.onBack) card.appendChild(backLink(cfg.onBack));
    swap(card, cfg.index);
  }

  /* ---------- Steg 1: Ålder ---------- */

  function showAge() {
    singleChoiceStep({
      index: 0,
      question: 'Hur gammal är din hund?',
      choices: AGES,
      selected: state.age,
      onPick: function (key) { state.age = key; showSize(); }
    });
  }

  /* ---------- Steg 2: Storlek ---------- */

  function showSize() {
    singleChoiceStep({
      index: 1,
      question: 'Hur stor är din hund?',
      choices: SIZES,
      selected: state.size,
      onPick: function (key) { state.size = key; showAreas(); },
      onBack: showAge
    });
  }

  /* ---------- Steg 3: Behovs-checklista ---------- */

  function showAreas() {
    state.stepIndex = 2;
    var card = el('div', 'sq-card');
    card.appendChild(el('h2', null, 'Vad vill du hjälpa din hund med?'));
    card.appendChild(el('p', 'sq-sub', 'Välj allt som stämmer.'));

    var opts = el('div', 'sq-options');
    var noneBtn;
    var next = el('button', 'sq-btn sq-next', 'Nästa');

    function syncButtons() {
      var btns = opts.querySelectorAll('.sq-opt[data-area]');
      Array.prototype.forEach.call(btns, function (b) {
        var on = state.areas.indexOf(b.dataset.area) >= 0;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (noneBtn) noneBtn.classList.toggle('is-selected', state.noneChosen);
      next.disabled = state.areas.length === 0 && !state.noneChosen;
      renderRail(2);
    }

    activeAreas().forEach(function (a) {
      var btn = el('button', 'sq-opt sq-opt-check sq-opt-icon',
        iconChip(a.icon) +
        '<span class="sq-opt-txt"><strong>' + esc(a.label) + '</strong><small>' + esc(a.hint) + '</small></span>' +
        '<span class="sq-check" aria-hidden="true"></span>');
      btn.type = 'button';
      btn.dataset.area = a.key;
      btn.addEventListener('click', function () {
        var i = state.areas.indexOf(a.key);
        if (i >= 0) { state.areas.splice(i, 1); }
        else { state.areas.push(a.key); state.noneChosen = false; }
        state.areas.sort(function (x, y) {
          return AREAS.findIndex(function (q) { return q.key === x; }) -
                 AREAS.findIndex(function (q) { return q.key === y; });
        });
        syncButtons();
      });
      opts.appendChild(btn);
    });

    noneBtn = el('button', 'sq-opt sq-opt-check sq-opt-icon',
      iconChip('heart') +
      '<span class="sq-opt-txt"><strong>Inget särskilt</strong><small>Jag är nyfiken på vad som skulle passa</small></span>' +
      '<span class="sq-check" aria-hidden="true"></span>');
    noneBtn.type = 'button';
    noneBtn.addEventListener('click', function () {
      state.noneChosen = !state.noneChosen;
      if (state.noneChosen) { state.areas = []; state.followups = {}; }
      syncButtons();
    });
    opts.appendChild(noneBtn);
    card.appendChild(opts);

    next.type = 'button';
    next.addEventListener('click', function () {
      Object.keys(state.followups).forEach(function (k) {
        if (state.areas.indexOf(k) < 0) delete state.followups[k];
      });
      if (state.areas.length === 0) { showEmailGate(); }
      else { showFollowup(0); }
    });
    card.appendChild(next);
    card.appendChild(backLink(showSize));
    syncButtons();
    swap(card, 2);
  }

  /* ---------- Steg 4+: Följdfrågor (flerval) ---------- */

  function showFollowup(idx) {
    var areas = followupAreas();
    if (idx >= areas.length) { showEmailGate(); return; }
    var area = areas[idx];
    state.stepIndex = 3 + idx;
    if (!state.followups[area.key]) state.followups[area.key] = [];

    var card = el('div', 'sq-card');
    card.appendChild(el('p', 'sq-area-tag', esc(area.label)));
    card.appendChild(el('h2', null, esc(area.question)));
    card.appendChild(el('p', 'sq-sub', 'Välj allt som stämmer.'));

    var opts = el('div', 'sq-options');
    var next = el('button', 'sq-btn sq-next', areas[idx + 1] ? 'Nästa' : 'Se min rekommendation');

    function syncButtons() {
      var btns = opts.querySelectorAll('.sq-opt');
      Array.prototype.forEach.call(btns, function (b, bi) {
        var on = state.followups[area.key].indexOf(bi) >= 0;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      next.disabled = state.followups[area.key].length === 0;
    }

    area.options.forEach(function (o, oi) {
      var btn = el('button', 'sq-opt sq-opt-check sq-opt-icon',
        iconChip(o.icon) +
        '<span class="sq-opt-txt"><strong>' + esc(o.label) + '</strong></span>' +
        '<span class="sq-check" aria-hidden="true"></span>');
      btn.type = 'button';
      btn.addEventListener('click', function () {
        var sel = state.followups[area.key];
        var i = sel.indexOf(oi);
        if (i >= 0) sel.splice(i, 1); else sel.push(oi);
        sel.sort(function (a, b) { return a - b; });
        syncButtons();
      });
      opts.appendChild(btn);
    });
    card.appendChild(opts);

    next.type = 'button';
    next.addEventListener('click', function () { showFollowup(idx + 1); });
    card.appendChild(next);
    card.appendChild(backLink(function () {
      if (idx === 0) showAreas(); else showFollowup(idx - 1);
    }));
    syncButtons();
    swap(card, state.stepIndex);
  }

  /* ---------- Valfri e-post innan resultatet ---------- */

  function showEmailGate() {
    if (state.emailDone) { showLoading(); return; }
    var card = el('div', 'sq-card sq-gate');
    card.appendChild(el('p', 'sq-area-tag', 'Sista steget'));
    card.appendChild(el('h2', null, 'Din hälsoplan är nästan klar'));
    card.appendChild(el('p', 'sq-sub',
      'Vill du ha hälsoplanen och rabattkoden ' + esc(DISCOUNT_CODE) + ' på mejlen? Fyll i din e-post – eller hoppa över.'));

    var form = el('form', 'sq-mail-form');
    form.innerHTML =
      '<input type="email" name="email" required placeholder="Din e-postadress" autocomplete="email" aria-label="E-postadress">' +
      '<button type="submit" class="sq-btn">Visa min rekommendation</button>';
    var msg = el('p', 'sq-mail-msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[name="email"]').value.trim();
      if (!email || email.indexOf('@') < 0) return;
      var btn = form.querySelector('button');
      btn.disabled = true;
      btn.textContent = 'Sparar';
      submitToKlaviyo(email, function () {
        /* Oavsett svar går vi vidare – mejlen får aldrig blockera resultatet */
        state.emailDone = true;
        showLoading();
      });
    });
    card.appendChild(form);
    card.appendChild(msg);

    var skip = el('button', 'sq-back sq-skip', 'Hoppa över och visa resultatet');
    skip.type = 'button';
    skip.addEventListener('click', function () {
      state.emailDone = true;
      showLoading();
    });
    card.appendChild(skip);

    var backTo = state.areas.length === 0
      ? showAreas
      : function () { showFollowup(followupAreas().length - 1); };
    card.appendChild(backLink(backTo));
    swap(card, null);
  }

  /* ---------- Laddskärm: "algoritmen" bearbetar svaren ---------- */

  function showLoading() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { showResults(); return; }

    var card = el('div', 'sq-card sq-loading');
    card.innerHTML =
      '<span class="sq-spinner" aria-hidden="true"></span>' +
      '<p class="sq-loading-txt" role="status">Analyserar dina svar&hellip;</p>';
    swap(card, null);

    var txt = card.querySelector('.sq-loading-txt');
    var steps = ['Matchar mot våra tillskott&hellip;', 'Sätter ihop din hälsoplan&hellip;'];
    var i = 0;
    var timer = setInterval(function () {
      if (i < steps.length) { txt.innerHTML = steps[i]; i++; }
      else { clearInterval(timer); showResults(); }
    }, 750);
  }

  /* ---------- Rekommendationslogik ---------- */

  function areaProducts(area) {
    var sel = state.followups[area.key] || [];
    var prods = [];
    var whyByProduct = {};
    sel.forEach(function (i) {
      var o = area.options[i];
      var pk = o.product || area.product;
      if (prods.indexOf(pk) < 0) { prods.push(pk); whyByProduct[pk] = o.why; }
      if (o.extra && prods.indexOf(o.extra) < 0) prods.push(o.extra);
    });
    if (!sel.length) {
      prods = [area.product];
      whyByProduct[area.product] = COMPLEMENT_WHY[area.product];
    }
    /* områdets huvudprodukt först om den finns med */
    prods.sort(function (a, b) {
      return (a === area.product ? -1 : 0) - (b === area.product ? -1 : 0);
    });
    return { prods: prods, whyByProduct: whyByProduct };
  }

  var BIG_MAX = 3; /* så många rekommendationer får stora block */
  var TRIO_KEYS = ['magbalans', 'smile', 'hudpals'];

  function buildRecommendation() {
    var rec = { items: [], overflow: [], showTrion: false, trioExact: false };

    if (state.areas.length === 0) {
      if (PRODUCTS.trion) {
        rec.items.push({
          key: 'trion',
          area: 'Vår rekommendation',
          why: 'Inget akut att fixa, då är helheten det smartaste valet. Trion samlar Magbalans, SMILE+ och Hud och Päls i ett paket som stödjer mage, mun och päls varje dag.'
        });
      } else {
        rec.items.push({ key: 'magbalans', area: 'Vår rekommendation', why: COMPLEMENT_WHY.magbalans });
      }
      return rec;
    }

    var chosen = followupAreas();
    var all = [];

    chosen.forEach(function (area) {
      var ap = areaProducts(area);
      ap.prods.forEach(function (pk) {
        all.push({ key: pk, area: area.label, why: ap.whyByProduct[pk] || COMPLEMENT_WHY[pk] });
      });
    });

    /* Områden utöver de tre första (utan följdfråga) tas också med */
    activeAreas().forEach(function (a) {
      if (state.areas.indexOf(a.key) >= 0 && chosen.indexOf(a) < 0 && PRODUCTS[a.product]) {
        all.push({ key: a.product, area: a.label, why: COMPLEMENT_WHY[a.product] });
      }
    });

    /* dedupe på produkt, behåll första förekomsten */
    var seen = {};
    all = all.filter(function (item) {
      if (seen[item.key] || !PRODUCTS[item.key]) return false;
      seen[item.key] = true;
      return true;
    });

    rec.items = all.slice(0, BIG_MAX);
    rec.overflow = all.slice(BIG_MAX);

    /* Trion-förslag när valen täcker minst två av mage/mun/hud (hud räknas när Hud och Päls ingår) */
    var trioAreas = 0;
    if (state.areas.indexOf('mage') >= 0) trioAreas++;
    if (state.areas.indexOf('mun') >= 0) trioAreas++;
    if (state.areas.indexOf('hud') >= 0) {
      var hudArea = AREAS.filter(function (a) { return a.key === 'hud'; })[0];
      if (areaProducts(hudArea).prods.indexOf('hudpals') >= 0) trioAreas++;
    }
    rec.showTrion = trioAreas >= 2 && !!PRODUCTS.trion;

    /* Är rekommendationen exakt trio-produkterna ersätter Trion-panelen "Lägg till allt" */
    var keys = rec.items.map(function (i) { return i.key; });
    rec.trioExact = rec.showTrion && rec.items.length === 3 && rec.overflow.length === 0 &&
      TRIO_KEYS.every(function (k) { return keys.indexOf(k) >= 0; });

    return rec;
  }

  function resultIngress() {
    var size = SIZES.filter(function (s) { return s.key === state.size; })[0];
    var age = AGES.filter(function (a) { return a.key === state.age; })[0];
    var who = 'en ' + (size ? size.word + ' ' : '') + (age ? age.word : 'hund');
    if (state.areas.length === 0) {
      return 'Anpassat efter ' + who + ' som mår bra och ska fortsätta göra det.';
    }
    var shorts = followupAreas().map(function (a) { return a.short; });
    var list = shorts.length === 1 ? shorts[0]
      : shorts.slice(0, -1).join(', ') + ' och ' + shorts[shorts.length - 1];
    return 'Anpassat efter ' + who + ' som behöver stöd med ' + list + '.';
  }

  /* ---------- Varukorg & rabattkod ---------- */

  function activateDiscount() {
    if (state.discountActivated) return Promise.resolve();
    state.discountActivated = true;
    return fetch('/discount/' + encodeURIComponent(DISCOUNT_CODE), { credentials: 'same-origin' })
      .catch(function () {});
  }

  function addToCart(variantId, btn, isGodis) {
    if (btn.disabled) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Lägger till';

    var chain = isGodis ? activateDiscount() : Promise.resolve();
    chain.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      state.cartCount++;
      btn.innerHTML = 'Tillagd';
      btn.classList.add('is-added');
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; btn.classList.remove('is-added'); }, 2500);
      updateCartBar();
      if (isGodis) showDiscountBadge();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {
      btn.innerHTML = 'Gick inte, testa igen';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2000);
    });
  }

  function updateCartBar() {
    var bar = document.getElementById('sq-cartbar');
    if (!bar || state.cartCount === 0) return;
    bar.classList.add('is-visible');
    var label = bar.querySelector('.sq-cartbar-label');
    if (label) label.textContent = state.cartCount === 1
      ? '1 produkt tillagd'
      : state.cartCount + ' produkter tillagda';
  }

  function showDiscountBadge() {
    var badge = document.getElementById('sq-discount-badge');
    if (badge) badge.classList.add('is-visible');
  }

  function saveQuizToCart() {
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _superquiz_alder: state.age || '',
          _superquiz_storlek: state.size || '',
          _superquiz_omraden: state.areas.join(',') || 'inget'
        }
      })
    }).catch(function () {});
  }

  /* ---------- Klaviyo ---------- */

  function submitToKlaviyo(email, callback) {
    var publicKey = root.dataset.klaviyoPublicKey;
    var listId = root.dataset.klaviyoListId;
    if (!publicKey || !listId) { callback(false); return; }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Super-quiz',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    superquiz_alder: state.age || '',
                    superquiz_storlek: state.size || '',
                    superquiz_omraden: state.areas.join(',') || 'inget',
                    superquiz_rabattkod: DISCOUNT_CODE
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    })
      .then(function (r) { callback(r.ok || r.status === 202); })
      .catch(function () { callback(false); });
  }

  /* ---------- Produkt-popup (Läs mer utan att lämna sidan) ---------- */

  function modalKeydown(e) {
    if (e.key === 'Escape') closeProductModal();
  }

  function closeProductModal() {
    var m = document.getElementById('sq-modal');
    if (m) m.remove();
    document.removeEventListener('keydown', modalKeydown);
    document.body.style.overflow = '';
  }

  function openProductModal(key) {
    var p = PRODUCTS[key];
    if (!p) return;
    closeProductModal();

    var overlay = el('div', 'sq-modal-overlay');
    overlay.id = 'sq-modal';
    var panel = el('div', 'sq-modal sq-enter');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', p.name);

    var close = el('button', 'sq-modal-close',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>');
    close.type = 'button';
    close.setAttribute('aria-label', 'Stäng');
    close.addEventListener('click', closeProductModal);
    panel.appendChild(close);

    var grid = el('div', 'sq-modal-grid');
    grid.innerHTML = '<div class="sq-modal-img"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '"></div>';

    var body = el('div', 'sq-modal-body');
    body.appendChild(el('h3', 'sq-modal-name', esc(p.name)));
    var st = starsRow(key);
    if (st) body.appendChild(el('p', 'sq-stars-row', st));
    if (p.desc) {
      var desc = el('div', 'sq-modal-desc');
      desc.innerHTML = p.desc; /* butikens egen produktbeskrivning */
      body.appendChild(desc);
    }
    var bullets = PRODUCT_BULLETS[key];
    if (bullets) {
      var ul = el('ul', 'sq-usps');
      bullets.forEach(function (b) {
        ul.appendChild(el('li', null,
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          esc(b)));
      });
      body.appendChild(ul);
    }

    if (PRODUCT_QUOTES[key]) {
      body.appendChild(el('blockquote', 'sq-quote',
        '&rdquo;' + esc(PRODUCT_QUOTES[key]) + '&rdquo; <span>– ur recensionerna</span>'));
    }

    var row = el('div', 'sq-buy-row');
    row.appendChild(priceEl(key));
    var add = el('button', 'sq-btn', 'Lägg i varukorgen');
    add.type = 'button';
    add.addEventListener('click', function () { addToCart(p.variant, add, GODIS_KEYS.indexOf(key) >= 0); });
    row.appendChild(add);
    body.appendChild(row);

    grid.appendChild(body);
    panel.appendChild(grid);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeProductModal();
    });
    document.addEventListener('keydown', modalKeydown);
    /* inuti .sq så CSS-variablerna (vit bakgrund m.m.) gäller */
    root.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    close.focus();
  }

  /* Gör en länk till en popup-öppnare (behåller href som fallback för ny flik) */
  function linkToModal(a, key) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      openProductModal(key);
    });
  }

  /* ---------- Resultat ---------- */

  /* Pris med överstruket jämförpris + Spara-pill när produkten är nedsatt */
  function priceEl(key) {
    var p = PRODUCTS[key];
    var wrap = el('span', 'sq-price-wrap');
    var html = '<span class="sq-price-group"><span class="sq-price">' + esc(p.price) + '</span>';
    var compare = parseInt(p.compareCents, 10) || 0;
    var pill = '';
    if (compare > (p.priceCents || 0)) {
      var pct = Math.round((1 - p.priceCents / compare) * 100);
      html += ' <s class="sq-price-old">' + money(compare) + '</s>';
      pill = '<span class="sq-save-pill">Spara ' + pct + ' %</span>';
    }
    wrap.innerHTML = html + '</span>' + pill;
    return wrap;
  }

  /* Rekommendationskort "Delad topp": 3:4-bild bara bredvid namn/område/stjärnor,
     sedan hairline och resten i full bredd. Citatet bor i Läs mer. */
  function recBlock(item, isSingle) {
    var key = item.key;
    var p = PRODUCTS[key];
    if (!p) return null;
    var block = el('section', 'sq-primary');

    var head = el('div', 'sq-primary-head');
    var img = el('a', 'sq-primary-img');
    img.href = p.url;
    img.innerHTML = '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '">';
    linkToModal(img, key);
    head.appendChild(img);
    var ht = el('div', 'sq-primary-ht');
    var nameEl = el('h3', 'sq-primary-name', '<a href="' + esc(p.url) + '">' + esc(p.name) + '</a>');
    linkToModal(nameEl.querySelector('a'), key);
    ht.appendChild(nameEl);
    ht.appendChild(el('p', 'sq-primary-sub', isSingle ? 'Vår rekommendation' : esc(item.area)));
    var st = starsRow(key, true);
    if (st) ht.appendChild(el('p', 'sq-stars-row', st));
    head.appendChild(ht);
    block.appendChild(head);

    var body = el('div', 'sq-primary-body');
    /* kort varför-rad: första meningen räcker på kortet, resten finns i Läs mer */
    var why = String(item.why || '');
    var cut = why.indexOf('. ');
    if (cut > 0 && cut < why.length - 2) why = why.slice(0, cut + 1);
    body.appendChild(el('p', 'sq-primary-why', esc(why)));

    var bullets = PRODUCT_BULLETS[key];
    if (bullets) {
      var ul = el('ul', 'sq-usps sq-usps-tight');
      bullets.slice(0, 2).forEach(function (b) {
        ul.appendChild(el('li', null,
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          esc(b)));
      });
      body.appendChild(ul);
    }

    body.appendChild(priceEl(key));

    var row = el('div', 'sq-rec-btns');
    var add = el('button', 'sq-btn sq-btn-sm', 'Lägg i varukorgen');
    add.type = 'button';
    add.addEventListener('click', function () { addToCart(p.variant, add, false); });
    row.appendChild(add);
    var more = el('a', 'sq-btn sq-btn-ghost sq-btn-sm', 'Läs mer');
    more.href = p.url;
    linkToModal(more, key);
    row.appendChild(more);
    body.appendChild(row);

    block.appendChild(body);
    return block;
  }

  function complementRow(key) {
    var p = PRODUCTS[key];
    if (!p) return null;
    var row = el('div', 'sq-comp');
    var img = el('a', 'sq-comp-img');
    img.href = p.url;
    img.innerHTML = '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy">';
    linkToModal(img, key);
    row.appendChild(img);
    var txt = el('div', 'sq-comp-txt');
    var nameP = el('p', 'sq-comp-name', '<a href="' + esc(p.url) + '">' + esc(p.name) + '</a>');
    linkToModal(nameP.querySelector('a'), key);
    txt.appendChild(nameP);
    txt.appendChild(el('p', 'sq-comp-why', esc(COMPLEMENT_WHY[key] || '')));
    row.appendChild(txt);
    var right = el('div', 'sq-comp-right');
    right.appendChild(el('span', 'sq-price', esc(p.price)));
    var add = el('button', 'sq-btn sq-btn-ghost sq-btn-sm', 'Lägg till');
    add.type = 'button';
    add.addEventListener('click', function () { addToCart(p.variant, add, false); });
    right.appendChild(add);
    row.appendChild(right);
    return row;
  }

  function godisRow(key) {
    var p = PRODUCTS[key];
    if (!p) return null;
    var item = el('div', 'sq-godis-item');
    var priceHtml = esc(p.price);
    if (p.priceCents) {
      priceHtml = '<s class="sq-price-old">' + esc(p.price) + '</s> ' +
        '<span class="sq-price-new">' + money(p.priceCents * DISCOUNT_FACTOR) + '</span>';
    }
    item.innerHTML =
      '<a class="sq-godis-img" href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy"></a>' +
      '<p class="sq-godis-name">' + esc(p.name) + '</p>' +
      '<p class="sq-godis-why">' + esc(GODIS_WHY[key] || '') + '</p>' +
      '<p class="sq-godis-price">' + priceHtml + '</p>';
    linkToModal(item.querySelector('.sq-godis-img'), key);
    var add = el('button', 'sq-btn sq-btn-ghost sq-btn-sm', 'Lägg till');
    add.type = 'button';
    add.addEventListener('click', function () { addToCart(p.variant, add, true); });
    item.appendChild(add);
    return item;
  }

  /* "Lägg till allt"-knappens logik, återanvänds i plan-rutan och Trion-panelen */
  function bindAddAll(btn, items, idleLabel) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.innerHTML = 'Lägger till';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (item) {
            return { id: PRODUCTS[item.key].variant, quantity: 1 };
          })
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        state.cartCount += items.length;
        btn.innerHTML = 'Tillagda';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = idleLabel;
          btn.classList.remove('is-added');
        }, 2500);
        updateCartBar();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {
        btn.innerHTML = 'Gick inte, testa igen';
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = idleLabel;
        }, 2000);
      });
    });
  }

  function trionPanel(rec) {
    var trion = PRODUCTS.trion;
    var banner = el('section', 'sq-trion');

    var imgWrap = el('a', 'sq-trion-img');
    imgWrap.href = trion.url;
    imgWrap.innerHTML = '<img src="' + esc(trion.img) + '" alt="' + esc(trion.name) + '" loading="lazy">';
    linkToModal(imgWrap, 'trion');
    banner.appendChild(imgWrap);

    var txt = el('div', 'sq-trion-txt');
    txt.appendChild(el('p', 'sq-badge sq-badge-green', 'Bästsäljare'));
    txt.appendChild(el('p', 'sq-trion-title', 'Trion – för hundens mage, mun & hud'));

    var separate = 0;
    if (PRODUCTS.magbalans && PRODUCTS.smile && PRODUCTS.hudpals) {
      separate = PRODUCTS.magbalans.priceCents + PRODUCTS.smile.priceCents + PRODUCTS.hudpals.priceCents;
    }
    var save = separate && trion.priceCents ? separate - trion.priceCents : 0;

    var why;
    if (rec.trioExact && save > 0) {
      why = 'Dina tre rekommendationer – Magbalans, SMILE+ och Hud och Päls – finns som paket för ' +
        esc(trion.price) + '. Var för sig kostar de ' + money(separate) + ', du sparar ' + money(save) + '.';
    } else if (save > 0) {
      why = 'Magbalans, SMILE+ och Hud och Päls i ett paket för ' + esc(trion.price) +
        '. Var för sig kostar de ' + money(separate) + ', du sparar ' + money(save) + '.';
    } else {
      why = 'Magbalans, SMILE+ och Hud och Päls i ett paket. Helhetsstöd för mage, mun och päls, ' + esc(trion.price) + '.';
    }
    txt.appendChild(el('p', 'sq-trion-why', why));

    var btns = el('div', 'sq-trion-btns');
    var tBtn = el('button', 'sq-btn', save > 0 ? 'Lägg Trion i varukorgen – spara ' + money(save) : 'Lägg Trion i varukorgen');
    tBtn.type = 'button';
    tBtn.addEventListener('click', function () { addToCart(trion.variant, tBtn, false); });
    btns.appendChild(tBtn);

    /* Är Trion ersättare för "Lägg till allt": ge var-för-sig som andrahandsval */
    if (rec.trioExact && separate > 0) {
      var sepBtn = el('button', 'sq-btn sq-btn-ghost', 'Hellre var för sig – ' + money(separate));
      sepBtn.type = 'button';
      bindAddAll(sepBtn, rec.items, 'Hellre var för sig – ' + money(separate));
      btns.appendChild(sepBtn);
    }
    txt.appendChild(btns);
    banner.appendChild(txt);
    return banner;
  }

  function showResults() {
    saveQuizToCart();
    root.classList.add('sq-is-results');
    var rec = buildRecommendation();
    var wrap = el('div', 'sq-results');

    var head = el('header', 'sq-results-head');
    head.appendChild(el('p', 'sq-results-check',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'));
    head.appendChild(el('h2', null, 'Din hälsoplan är klar'));
    head.appendChild(el('p', 'sq-results-sub', esc(resultIngress())));
    wrap.appendChild(head);

    /* Varför handla hos oss */
    var trustIcon = function (name) { return SVG_OPEN + ICONS[name] + '</svg>'; };
    wrap.appendChild(el('ul', 'sq-trust',
      '<li>🇸🇪 Svensktillverkat</li>' +
      '<li><span class="sq-trust-star">' + STAR_PATH + '</span> 4,2 av 5 · 558 recensioner</li>' +
      '<li>' + trustIcon('truck') + ' Fri frakt från 599 kr</li>' +
      '<li>' + trustIcon('undo') + ' 30 dagars öppet köp</li>'));

    rec.items.forEach(function (item) {
      var block = recBlock(item, rec.items.length === 1);
      if (block) wrap.appendChild(block);
    });

    /* Hela planen med ett klick – eller Trion-paketet när det täcker exakt samma produkter */
    if (rec.trioExact) {
      wrap.appendChild(trionPanel(rec));
    } else {
      if (rec.items.length >= 2) {
        var totalCents = rec.items.reduce(function (sum, item) {
          return sum + (PRODUCTS[item.key].priceCents || 0);
        }, 0);
        var addAll = el('div', 'sq-addall');
        var info = el('div', 'sq-addall-info');
        info.appendChild(el('p', 'sq-addall-title', 'Stötta din hund med hela planen'));
        var list = el('ul', 'sq-addall-list');
        rec.items.forEach(function (item) {
          var p = PRODUCTS[item.key];
          list.appendChild(el('li', null,
            '<img src="' + esc(p.img) + '" alt="" loading="lazy"><span>' + esc(p.name) + '</span>'));
        });
        info.appendChild(list);
        addAll.appendChild(info);
        var right = el('div', 'sq-addall-right');
        right.appendChild(el('p', 'sq-addall-txt',
          rec.items.length + ' produkter: <strong>' + money(totalCents) + '</strong>'));
        var allBtn = el('button', 'sq-btn', 'Lägg till allt');
        allBtn.type = 'button';
        bindAddAll(allBtn, rec.items, 'Lägg till allt');
        right.appendChild(allBtn);
        addAll.appendChild(right);
        wrap.appendChild(addAll);
      }
      if (rec.showTrion) wrap.appendChild(trionPanel(rec));
    }

    if (rec.overflow.length) {
      var compSection = el('section', 'sq-comps');
      compSection.appendChild(el('h3', 'sq-section-title', 'Passar också din hund'));
      rec.overflow.forEach(function (item) {
        var c = complementRow(item.key);
        if (c) compSection.appendChild(c);
      });
      wrap.appendChild(compSection);
    }

    /* Godis-upsell */
    var godis = el('section', 'sq-godis');
    godis.appendChild(el('h3', 'sq-section-title', 'Få ' + DISCOUNT_PCT + ' % på svenskt godis samtidigt'));
    godis.appendChild(el('p', 'sq-godis-sub', 'Köp dina tillskott och fira med något gott. Rabatten aktiveras automatiskt när du lägger till godiset.'));
    var badge = el('p', 'sq-discount-badge', 'Rabattkoden ' + esc(DISCOUNT_CODE) + ' är aktiverad och dras av i kassan.');
    badge.id = 'sq-discount-badge';
    godis.appendChild(badge);
    var grid = el('div', 'sq-godis-grid');
    GODIS_KEYS.forEach(function (k) {
      var c = godisRow(k);
      if (c) grid.appendChild(c);
    });
    godis.appendChild(grid);
    wrap.appendChild(godis);

    /* Gör om */
    var redo = el('button', 'sq-back sq-redo', 'Gör om quizet');
    redo.type = 'button';
    redo.addEventListener('click', function () {
      state.age = null;
      state.size = null;
      state.areas = [];
      state.followups = {};
      state.noneChosen = false;
      state.emailDone = false;
      root.classList.remove('sq-is-results');
      showAge();
    });
    wrap.appendChild(redo);

    /* Sticky varukorgs-rad */
    var bar = el('div', 'sq-cartbar');
    bar.id = 'sq-cartbar';
    bar.innerHTML = '<span class="sq-cartbar-label"></span>';
    var toCart = el('a', 'sq-btn sq-btn-sm sq-cartbar-btn', 'Gå till varukorgen');
    toCart.href = '/cart';
    bar.appendChild(toCart);
    wrap.appendChild(bar);

    swap(wrap, null);
    if (state.cartCount > 0) updateCartBar();
  }

  /* ---------- Start ---------- */
  showAge();
})();
